<template>
  <div class="wizard-steps mb-5">
    <div class="wizard-step" :class="stepClass(1)">
      <span class="wizard-step-index">1</span>
      <span class="wizard-step-text">Selecionar Dashes e Tenant Modelo</span>
    </div>
    <div class="wizard-step" :class="stepClass(2)">
      <span class="wizard-step-index">2</span>
      <span class="wizard-step-text">Configurar Identificadores</span>
    </div>
    <div class="wizard-step" :class="stepClass(3)">
      <span class="wizard-step-index">3</span>
      <span class="wizard-step-text">Revisar, Validar e Executar</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MassCampaignWizardProgress',
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
  },
  methods: {
    stepClass(step) {
      return {
        active: this.currentStep === step,
        done: this.currentStep > step,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.wizard-steps {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.wizard-step {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 999px;
  padding: 6px 10px;
  background: #f7f7f7;
}

.wizard-step-index {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #d8d8d8;
  color: #333;
  font-size: 11px;
  font-weight: 700;
}

.wizard-step-text {
  font-size: 12px;
  font-weight: 600;
}

.wizard-step.active {
  border-color: #2a8bf2;
  background: #eef6ff;
}

.wizard-step.active .wizard-step-index {
  background: #2a8bf2;
  color: #fff;
}

.wizard-step.done {
  border-color: #24a148;
  background: #edf9f1;
}

.wizard-step.done .wizard-step-index {
  background: #24a148;
  color: #fff;
}
</style>
